import { boolean, object, array } from "yup";

import { ConsentsFormState } from "../types";
import { AdditionalInterestFormData } from "../../AdditionalInterest";

export interface StripeFormState extends ConsentsFormState {
  additionalInterests: AdditionalInterestFormData[];
}

export const defaultValues: StripeFormState = {
  customerESign: false,
  agentSignResponsibility: false,
  additionalInterests: [],
};

export const createStripeFormValidationSchema = (
  isD2C: boolean,
  forceAgentSignResponsibility?: boolean | null
) =>
  object({
    customerESign: isD2C
      ? boolean().required().isTrue()
      : boolean().optional().nullable(),
    agentSignResponsibility:
      !isD2C && forceAgentSignResponsibility
        ? boolean().required().isTrue()
        : boolean().optional().nullable(),
    additionalInterests: array().default([]),
  });
